import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import sendGtmAddToCartOperation from 'store/category/operation/sendGtmAddToCartOperation';
import { setAddingToCartFlowAction, setLastOrderItemIdsAction } from '../slice';
import getProductId from '../selector/getProductId';
import { AddToCartFlow } from '../types';
import getCommonProductRequestParams from '../selector/getCommonProductRequestParams';
import getSelectedBundleProducts from '../selector/getSelectedBundleProducts';
import addToBasketSelectedBundleProductsOperation from './addToBasketSelectedBundleProductsOperation';
import getPredesignedProductItem from '../selector/getPredesignedProductItem';

const addToBasketPredesignedProductOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const { categoryId, quantity } = getCommonProductRequestParams(store);
    const productItem = getPredesignedProductItem(store);
    const encPublicDesignId = productItem?.encDesignId;
    const selectedBundleProducts = getSelectedBundleProducts(store).filter(
      (selectedProduct) => selectedProduct.productId > 0,
    );

    const productId = getProductId(store);
    dispatch(setAddingToCartFlowAction(AddToCartFlow.addingToCart));

    apiRequest(
      endpoints.customerCartV1PublicDesignAdd,
      {
        productId,
        categoryId,
        encPublicDesignId,
        includeAnalytics: true,
        quantity,
      },
      HttpMethods.POST,
      'data',
    )
      .then((result: any) => {
        const { orderItemId, encOrderItemId } = result;
        dispatch(
          setLastOrderItemIdsAction({
            orderItemId,
            encOrderItemId,
          }),
        );
        dispatch(sendGtmAddToCartOperation());
        if (!selectedBundleProducts.length) {
          dispatch(setAddingToCartFlowAction(AddToCartFlow.addedToCart));
          return;
        }
        dispatch(addToBasketSelectedBundleProductsOperation());
      })
      .catch(() => {
        dispatch(setAddingToCartFlowAction(AddToCartFlow.failedToAddToCart));
      });
  };

export default addToBasketPredesignedProductOperation;
